import  { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DetailPageLayout from  "../../../Components/Layout/DetailPageLayout";
import ProfileIcon from "../../../Assets/IconComponents/ProfileIcon";
import ContactIcon from "../../../Assets/IconComponents/ContactIcon";
import RtiTracker from "./RtiTracker";
import ApprenticeDocument from "./ApprenticeDocument";
import ApprenticeProfile from "./ApprenticeProfile";
import CourseEnrollment from './CourseEnrollment';
import { useTheme } from "../../../ContextStore/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { handleLogout, userSelector } from "../../../store/features/auth/authSlice";
import logo from "../../../Assets/Icons/logo.png";
import logoWhite from "../../../Assets/Icons/logo-white.png";
import menuopen from "../../../Assets/Icons/menu-open.png";
import menuclose from "../../../Assets/Icons/menu-close.png";
import NotificationIcon from "../../../Assets/IconComponents/Notification";
import { headerMenus } from "../../../../utils/MenusConfig";
import HelpMenu from "../../../Components/Header/HelpMenu";
import { Layout } from "@proscore-ai/proscore-ui-library";

export default function ApprenticeDetail() {
  const { tab, id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("");
  const [clientSubTitle] = useState("");
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const user = useSelector(userSelector);

  const onLogout = () => dispatch(handleLogout());
  const onTabClick = ({ to }) => navigate(to);
  const onLogoClick = () => navigate("/clients");

  const tabs = [
    {
      to: "/profile",
      title: "Profile",
      key: "profile",
      isActive: false,
      hasArrow: false,
      icon: ProfileIcon
    },
    {
      to: "/rti-tracker",
      title: "RTI Tracker",
      key: "rti-tracker",
      isActive: false,
      hasArrow: false,
      icon: ProfileIcon
    },
    {
      to: "/documents",
      title: "Documents",
      key: "documents",
      isActive: false,
      hasArrow: false,
      icon: ContactIcon
    },
    {
      to: "/course-enrollments",
      title: "Course Enrollments",
      key: "course-enrollments",
      isActive: false,
      hasArrow: false,
      icon: ContactIcon
    }
  ];

  const backAction = () => { 
    navigate("/apprentice-management");
  };

  const handleTabClick = tab => {
    navigate(`/apprentice-management/${id}${tab.to}`);
  };

  useEffect(() => {
    const selectedTab = tabs.find(t => t.key === tab?.toLowerCase())?.title;
    setActiveTab(selectedTab || "Profile");
  }, [tab]);

  return (
    <Layout
      theme={theme}
      user={user}
      onLogout={onLogout}
      onTabClick={onTabClick}
      onLogoClick={onLogoClick}
      logo={logo}
      logoWhite={logoWhite}
      menuOpenIcon={menuopen}
      menuCloseIcon={menuclose}
      menuTabs={headerMenus}
      NotificationIcon={NotificationIcon}
      HelpComponent={HelpMenu}
    >
      {activeTab && (
        <DetailPageLayout
          backAction={backAction}
          tabs={tabs}
          title={"APPRENTICE INFORMATION"}
          subTitle={clientSubTitle}
          backLabel="Go back to Apprentice Management"
          activeTab={activeTab}
          handleTabClick={handleTabClick}
        >
          {activeTab === "Profile" && <ApprenticeProfile />}
          {activeTab === "RTI Tracker" && <RtiTracker />}
          {activeTab === "Documents" && <ApprenticeDocument />}
          {activeTab === "Course Enrollments" && <CourseEnrollment />}
        </DetailPageLayout>
      )}
    </Layout>
  );
}
